import type { ReactNode } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type DeepLinkLayoutProps = { children: ReactNode };

export default function DeepLinkLayout({ children }: DeepLinkLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const entryPaths = ["/", "/liff"];
    if (!entryPaths.includes(location.pathname)) {
      return;
    }
    const params = new URLSearchParams(location.search ?? "");
    if (params.get("project") !== "ec") {
      return;
    }
    const productId = parseInt(params.get("productId") ?? "", 10);
    const seriesId = parseInt(params.get("seriesId") ?? "", 10);

    const hasProduct = Number.isFinite(productId) && productId > 0;
    const hasSeries = Number.isFinite(seriesId) && seriesId > 0;

    params.delete("project");
    params.delete("productId");
    params.delete("seriesId");
    params.delete("product");
    params.delete("series");

    const rest = params.toString();
    const restQuery = rest ? `?${rest}` : "";

    if (hasProduct) {
      navigate(`/ec/product/${productId}${restQuery}`, { replace: true });
      return;
    }
    if (hasSeries) {
      navigate(`/ec/series/${seriesId}${restQuery}`, { replace: true });
      return;
    }
    navigate(`/ec${restQuery}`, { replace: true });
  }, [navigate, location.pathname, location.search]);

  return <>{children}</>;
}
